<script setup lang="ts">
import { watchOnce } from "@vueuse/core"
import { ref } from "vue"
import { cn } from '../../../lib/utils'
import { useCarousel } from './useCarousel'

interface Props {
  initialCount?: number,
}

const props = defineProps<Props>();

const { carouselApi } = useCarousel()

const totalCount = ref(props.initialCount ?? 0)
const current = ref(0)

watchOnce(carouselApi, (api) => {
  if (!api)
    return

  totalCount.value = api.scrollSnapList().length
  current.value = api.selectedScrollSnap() + 1

  api.on('select', () => {
    current.value = api.selectedScrollSnap() + 1
  })
})

</script>

<template>
  <div class="flex flex-row gap-8">
    <div v-for="index in totalCount" :class="cn('c-carousel-indicator__dot', {'opacity-40': index !== current})">
    </div>
  </div>
</template>

<style scoped>
.c-carousel-indicator__dot {
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: currentColor;
}
</style>
